import React, { Component, useEffect } from 'react';
import Slider from 'react-slick';
import CountUp from 'react-countup';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setDataHomes, setDataNews } from 'src/config/redux/action'
import { Link } from 'react-router-dom';
import { ILTest } from 'src/assets/image';
import { Player, BigPlayButton } from 'video-react';
import "video-react/dist/video-react.css"; 

const MainPageHome = () => {
    const { dataHomes, dataNews } = useSelector(state => state.homeReducer)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setDataHomes())
        dispatch(setDataNews())
    }, [dispatch])

    var slick_kategori = {
          dots: false,
          arrow: false,
          autoplay: true,
          infinite: true,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,

          responsive: [{

            breakpoint: 1199,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3
            }
        },
        {
      
            breakpoint: 680,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    };
    const slick_berita = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
        dataHomes &&
            <div className="site-main">
                <section className="ttm-row ttm-bgcolor-grey py-5 clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title with-desc text-center clearfix">
                                    <div className="title-header">
                                        <h2 className="title">Telusuri Berdasarkan  <span>Kategori</span></h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Slider className="row slick_slider ttm-boxes-spacing-30px" {...slick_kategori} slidesToShow={4}>
                            {
                                dataHomes.Categories.map((v, i) => {
                                    return (
                                        <div className="ttm-box-col-wrapper" key={i}>
                                            <div className="featured-icon-box style6" style={{ minHeight: '480px' }}>
                                                <div className="featured-content">
                                                    <center>
                                                        <img src={v.FileLogo} className="img-fluid" />
                                                    </center>
                                                    <div className="featured-title mt-3">
                                                        <h5>{v.Name}</h5>
                                                    </div>
                                                    <div className="featured-desc">
                                                        <p style={{ WebkitLineClamp: 3, textOverflow: 'ellipsis', display: '-webkit-box', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{v.Description}.</p>
                                                    </div>
                                                </div>
                                                <div className="featured-icon">
                                                </div>
                                                <Link to={`/kategori/detail/${v.Slug}`} className="ttm-btn btn-inline style2">Dataset({v.DatasetCount}) </Link>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </Slider>
                        
                    </div>
                </section>
              
              
                {
                    dataNews &&
                    <>
                        <section className="ttm-row ttm-bgcolor-grey py-5 pb-5 clearfix">
                            <div className="container-xl">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-title with-desc text-center clearfix">
                                            <div className="title-header">
                                                <h2 className="title">Informasi Berita <span>Satu Data</span></h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <Slider className="row no-gutters position-relative z-1" {...slick_berita} >
                                    {
                                        dataNews.map((v, i) => {
                                            return (
                                                    <div key={i} className="col-md-12">
                                                        <div className="ttm-bgcolor-white ttm-bg ttm-col-bgcolor-yes ttm-left-span ttm-left-span spacing-7">
                                                            <div className="layer-content">
                                                                <div className="row">
                                                                    <div className="col-lg-6">
                                                                        <div className="ttm_single_image-wrapper">
                                                                            {
                                                                                v.Type === 1 ?
                                                                                    <img className="img-fluid" src={v.FileName} title="single-img-five" alt="single-img-five" />
                                                                                    :
                                                                                    <Player
                                                                                        playsInline
                                                                                        src={v.FileName}
                                                                                >
                                                                                    <BigPlayButton position="center" />
                                                                                    </Player>
                                                                                    
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <div className="res-991-mt-30">
                                                                            <div className="section-title with-desc clearfix">
                                                                                <div className="title-header">
                                                                                    <h5>{v.Header}</h5>
                                                                                    <h2 className="title">{v.Title}</h2>
                                                                                </div>
                                                                                <div className="title-desc">
                                                                                    <p>{v.Description}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                            )
                                        })
                                    }
                                </Slider>
                            </div>
                        </section>
                    </>
                }
                       
                {/* <section className="ttm-row fid-section ttm-bgcolor-darkgrey ttm-bg ttm-bgimage-yes bg-img10 mt_225 res-991-mt-0 clearfix"> */}
                <section className="ttm-row ttm-bgcolor-darkgrey ttm-bg ttm-bgimage-yes bg-img10 clearfix">
                    <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-4 col-6">
                                <div className="ttm-fid inside ttm-fid-view-topicon">
                                    <div className="ttm-fid-icon-wrapper">
                                        <div className="ttm-icon ttm-bgcolor-skincolor ttm-icon_element-size-lg">
                                            <i className="flaticon flaticon-online-library" />
                                        </div>
                                    </div>
                                    <div className="ttm-fid-contents">
                                        <h4>
                                            <CountUp start={0} end={dataHomes.DataCount.Dataset} duration={30} />
                                        </h4>
                                        <h3 className="ttm-fid-title">Dataset</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-6">
                                <div className="ttm-fid inside ttm-fid-view-topicon">
                                    <div className="ttm-fid-icon-wrapper">
                                        <div className="ttm-icon ttm-bgcolor-skincolor ttm-icon_element-size-lg">
                                            <i className="flaticon flaticon-24h" />
                                        </div>
                                    </div>
                                    <div className="ttm-fid-contents">
                                        <h4>
                                            <CountUp start={0} end={dataHomes.DataCount.Agency} duration={30} />
                                        </h4>
                                        <h3 className="ttm-fid-title">Organisasi</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-6">
                                
                                <div className="ttm-fid inside ttm-fid-view-topicon">
                                    <div className="ttm-fid-icon-wrapper">
                                        <div className="ttm-icon ttm-bgcolor-skincolor ttm-icon_element-size-lg">
                                            <i className="flaticon flaticon-report" />
                                        </div>
                                    </div>
                                    <div className="ttm-fid-contents">
                                        <h4>
                                            <CountUp start={0} end={dataHomes.DataCount.Category} duration={30} />
                                        </h4>
                                        <h3 className="ttm-fid-title">Kategori</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </section>
                

            </div>
            
    )
}


export default MainPageHome;
